import fetch from "auth/FetchInterceptor";

const jornadaService = {};

/**
 * Próximo passo ativo ainda não concluído pelo profissional.
 * Resposta: { concluida, passo: { chave, titulo, descricao, url_video, ordem } | null, total, concluidos }
 */
jornadaService.obterProximoPasso = async function () {
	return fetch({
		url: "/v1/rest/jornada/proximo-passo",
		method: "get",
	});
};

/**
 * Progresso completo da jornada (todos os passos ativos + status + recompensa).
 * Resposta: { jornada_concluida, total, concluidos, recompensa: { valor, descricao }, passos: [...] }
 */
jornadaService.obterProgresso = async function () {
	return fetch({
		url: "/v1/rest/jornada",
		method: "get",
	});
};

/**
 * Marca o passo "ver vídeo de ajuda" como concluído. Chamado ao fechar o modal
 * do botão "Ver ajuda". Idempotente no backend.
 */
jornadaService.marcarVideoAjudaVisto = async function () {
	return fetch({
		url: "/v1/rest/jornada/video-ajuda-visto",
		method: "post",
	});
};

export default jornadaService;
